const AuthModule = () => import(/* webpackChunkName: "account-module" */ './views/Module.vue');
const  ChangePassword = () => import(/* webpackChunkName: "account-module" */ '../authorization/components/ChangePassword.vue');
const  SecurityAndAuth = () => import(/* webpackChunkName: "account-module" */ '../authorization/components/SecurityAndAuth.vue');
const  Login = () => import(/* webpackChunkName: "account-module" */ '../authorization/components/Login.vue');

const AuthRoutes =  {
    path: '/',
    component: AuthModule,
    children: [
     
        {
            path: '/change-password',
            name: 'change-password',
            component: ChangePassword,
          },

          {
            path: '/security-and-auth',
            name: 'Security-and-auth',
            component: SecurityAndAuth,
          },
    ],
  }

export default AuthRoutes;